import { render, staticRenderFns } from "./linggong.vue?vue&type=template&id=640a3002&scoped=true&"
import script from "./linggong.vue?vue&type=script&lang=js&"
export * from "./linggong.vue?vue&type=script&lang=js&"
import style0 from "./linggong.vue?vue&type=style&index=0&id=640a3002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640a3002",
  null
  
)

export default component.exports